import React, { Component } from "react";
import TableRecord from "../../../Components/UI/TableRecord";
import CreateDomainCertificate from "./CreateDomainCertificate";
import { callPOST } from "../../../Utils/ApiUtil";
import Modal from "react-bootstrap/Modal";
import { Pagination } from "reactstrap";

class SearchCertificate extends Component{
    constructor(props){
        super(props);
        this.state={
            isCertificateModelOpen :false,
            formFieldData: {
                id: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                unique_name: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                common_name: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                company_name: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                department_name: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                key_size: {
                  value: "2048",
                  failMessage: "",
                  disabled:false
                },
                state_name: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                email_id: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                city_name: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                country_code: {
                  value: "",
                  failMessage: "",
                  disabled:false
                },
                is_active: {
                  value: false,
                  failMessage: "",
                  disabled:false
                },
              },
              tableRecords:{
                
              }
        }
    }

    componentDidMount=()=>{
      console.log('componentDidMomunt')
    } 
    componentDidUpdate=()=>{
      console.log('componentDidUpdate')
    }

     //Get available Certificate for domain certificate configuration
  // getAvailableCertificate = (paginationRequest) => {
  //   console.log("getAvailableCertificate START");
  //   const { Loader } = this.props;
  //   let pagination = this.state.CertificateSearchTableRecord.pagination;
  //   if (paginationRequest !== null && paginationRequest !== undefined) {
  //     pagination = paginationRequest;
  //   }
  //   const page = pagination.page;
  //   const orderBy = pagination.orderBy;
  //   const perPage = pagination.perPage;
  //   const direction = pagination.direction;
  //   const search = pagination.search;
  //   Loader();
  //   const queryString =
  //     "?query=" +
  //     search +
  //     "&page=" +
  //     page +
  //     "&orderBy=" +
  //     orderBy +
  //     "&size=" +
  //     perPage +
  //     "&direction=" +
  //     direction;
  //   let API_URL = "domain/certificate/search/active";

  //   callGET(API_URL + queryString).then(
  //     (response) => {
  //       if (response.status === 200) {
  //         const responseData = response.data.data;
  //         console.log("responseData", responseData);

  //         let updateTableData = [];
  //         responseData.content.map((item) => {
  //           console.log("i", item);
  //           const domain = this.state.item;
  //           if (item.is_active === true) {
  //             let fieldRow = {
  //               RadioButton: {
  //                 checked:
  //                   domain.certificate_id !== undefined &&
  //                   domain.certificate_id === item.id
  //                     ? true
  //                     : false,
  //                 name: "CertificateCheckbox",
  //               },
  //               lable_name: {
  //                 value: item.common_name !== undefined ? item.common_name : "",
  //                 className: "text-info textUnderline cursor-pointer",
  //               },
  //               type: item.type !== undefined ? item.type : "-",
  //               is_active: {
  //                 checked: item.is_active,
  //               },
  //               created_at: item.created_at,
  //               certificate_expiry:
  //                 item.expiry_date !== undefined
  //                   ? moment(item.expiry_date).format(getDateFormat())
  //                   : "-",
  //             };

  //             updateTableData.push({
  //               clickHandler: this.CheckBoxClickHandler.bind(this, item.id),
  //               className:
  //                 domain.certificate_id !== undefined &&
  //                 domain.certificate_id === item.id
  //                   ? "selected"
  //                   : "",
  //               rowId: item.id,
  //               data: fieldRow,
  //             });
  //           }
  //         });

  //         console.log("getAvailableCertificate Data", updateTableData);
  //        const totalRecords = responseData.total_elements;
  //         this.setState({
  //           CertificateSearchTableRecord: {
  //             tableData: { data: updateTableData, status: 200 },
  //             tableHead: this.state.CertificateSearchTableRecord.tableHead,
  //             pagination: {
  //               ...this.state.CertificateSearchTableRecord.pagination,
  //               totalRecords: totalRecords,
  //             },
  //           },
  //         });
  //       }
  //    Loader();
  //     },
  //     (error) => {
  //       console.log("error", error);
  //       Loader();
  //     }
  //   );
  //   console.log("getAvailableCertificate END", this.state);
  // };

    toggleCreateNewCertificate = () => {
        let updateState = this.clearFormFields(this.state.formFieldData);
        this.setState({
          formFieldData: updateState,
          isCertificateModelOpen:!this.state.isCertificateModelOpen,
        });
    };
    
      clearFormFields = (updateState) => {
        
        console.log("clearFormFields", updateState);
        updateState.id = { value: "", failMessage: "",disabled:false };
        updateState.unique_name = { value: "", failMessage: "",disabled:false};
        updateState.common_name = { value: "", failMessage: "",disabled:false };
        updateState.company_name = { value: "", failMessage: "",disabled:false };
        updateState.department_name = { value: "", failMessage: "",disabled:false };
        updateState.key_size = { value: "2048", failMessage: "",disabled:false };
        updateState.state_name = { value: "", failMessage: "",disabled:false };
        updateState.email_id = { value: "", failMessage: "" ,disabled:false};
        updateState.city_name = { value: "", failMessage: "" ,disabled:false};
        updateState.country_code = { value: "", failMessage: "",disabled:false };
        updateState.is_active = { value: false, failMessage: "",disabled:false };
        return updateState;
      };
      certificateValueChangeHandler = (e) => {
        console.log("valuehandler=-======>", e);
        let name = e.target.name;
        let value = e.target.value;
        if (name === "certificateTextArea") {
          this.setState({
            certificateTextArea: value,
          });
          return;
        }
        if (name === "keyChainTextArea") {
          this.setState({
            keyTextArea: value,
          });
          return;
        }
        console.log("name", name, "value", value);
        const formFieldData = this.state.formFieldData;
        let update = { ...formFieldData[name], value: value, failMessage: "" };
    
        this.setState({
          formFieldData: { ...formFieldData, [name]: { ...update } },
        });
      };
    
      PickListChangeHandler = (value) => {
        console.log("PickListCHangeHandler", value);
        const formFieldData = this.state.formFieldData;
        let update = {
          ...formFieldData["country_code"],
          value: value,
          failMessage: "",
        };
        this.setState({
          formFieldData: {
            ...formFieldData,
            country_code: { ...update },
          },
        });
      };

      // searchCertificateChangeHandler=async (paginationRequest, loader) =>{
      //   console.log('searchCertificateHandler',paginationRequest,"loader",loader);
        
      //   const tableRecords =this.state.CertificateSearchTableRecord;
      //   let pagination = tableRecords.pagination;
      //   if (paginationRequest !== undefined && paginationRequest !== null) {
      //     pagination = { pagination, ...paginationRequest };
    
      //     this.setState({ CertificateSearchTableRecord: {...tableRecords,pagination:pagination} });
      //     this.getAvailableCertificate(pagination);
      //   }
      // }
    

    
    
      saveHandler = (validation = "false") => {
        const {
          id,
          unique_name,
          common_name,
          company_name,
          department_name,
          key_size,
          state_name,
          email_id,
          city_name,
          country_code,
        } = this.state.formFieldData;
        const body = {
          id: id.value,
          unique_name: unique_name.value,
          common_name: common_name.value,
          company_name: company_name.value,
          city_name: city_name.value,
          email_id: email_id.value,
          country_code: country_code.value,
          state_name: state_name.value,
          department_name: department_name.value,
          key_size: key_size.value,
        };
        const header = { "Content-Type": "application/json" };
        this.props.Loader();
        callPOST("domain/certificate/save", body, header).then(
          (response) => {
            console.log("response", response);
            const responseData = response.data;
            this.props.Loader();
            if (response.status === 200) {
              if (responseData.code === 200) {
                this.props.succMessage("Certificate Created Successfully , Get your certificate signed and add to your domain");
                // this.getCertificateList();
               
                this.toggleCreateNewCertificate();

              } else if (responseData.code === 400) {
                let updateFormField = this.state.formFieldData;
                responseData.violations.map((item) => {
                  console.log("violations", item);
                  let update = {
                    ...updateFormField[item.field_name],
                    failMessage: item.message,
                  };
                  updateFormField = {
                    ...updateFormField,
                    [item.field_name]: { ...update },
                  };
                });
                console.log("final fieldData", updateFormField);
                this.setState({
                  formFieldData: updateFormField,
                });
              }
            } else {
              this.props.failMessage(responseData.message);
            }
          },
          (error) => {
            console.log("error", error);
            this.props.Loader();
          }
        );
      };

      toggleCertificate = ()=>{
        this.setState({
            isCertificateModelOpen:!this.state.isCertificateModelOpen
        })
      }





    render(){
        const {isModelOpen,tableRecords,toggleModel,saveHandler,searchCertificateChangeHandler,SelectedCertificateId} = this.props;
        console.log('tableRecords',tableRecords,searchCertificateChangeHandler);
        return(
          <Modal size="fullscreen"  show={isModelOpen} onHide={toggleModel}>
            <Modal.Header>
            <h6 className="mb-0"> Search Certificate
                            <div className="btn-right">
                                {/* <a className="btn primary_bg cursor-pointer" onClick={this.toggleCreateNewCertificate} >Add New Certificate</a> */}
                            </div>
                        </h6>
            </Modal.Header>
            <Modal.Body>
            <CreateDomainCertificate
                            formFieldData={this.state.formFieldData}
                            toggleModel={this.toggleCertificate}
                            isCreateNewModelOpen={this.state.isCertificateModelOpen}
                            valueChangeHandler={this.certificateValueChangeHandler}
                          countryChangeHandler={this.PickListChangeHandler}
                          saveHandler={this.saveHandler}
                        />   
                            <TableRecord
                                tableRecords={tableRecords}
                                recordsChangeHandler={searchCertificateChangeHandler}
                                />
            </Modal.Body>

            <Modal.Footer>
             <div className="ml-md-auto py-2 py-md-0">
                  {/* <a onClick={toggleModel} className="btn btn-border border-default mr-2"> Cancel </a> 
                  <a onClick={saveHandler} className="btn primary_bg" disabled={true}> Save </a>  */}
                <button
              type="button"
              className="btn btn-border border-default mr-2"
              onClick={toggleModel}
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn primary_bg"
              onClick={saveHandler}
              disabled={SelectedCertificateId===""}
            >
              Save
            </button>
              </div>
            </Modal.Footer>
            </Modal>);
            {/* <div
                    className={(isModelOpen)?"modal fade show":"modal fade"}
                    id="c_Search"
                    role="dialog"
                    tabIndex={-1}
                    data-backdrop="static"
                    data-keyboard="false"
            >
                <div className="modal-dialog modal-fullscreen" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="mb-0"> Search Certificate
                            <div className="btn-right">
                                <a className="btn primary_bg cursor-pointer" onClick={this.toggleCreateNewCertificate} >Add New Certificate</a></div>
                        </h6>
                    </div>
                    <div className="modal-body p-0">
                        
                            <CreateDomainCertificate
                            formFieldData={this.state.formFieldData}
                            toggleModel={this.toggleCertificate}
                            isCreateNewModelOpen={this.state.isCertificateModelOpen}
                            valueChangeHandler={this.certificateValueChangeHandler}
                          countryChangeHandler={this.PickListChangeHandler}
                          saveHandler={this.saveHandler}
                        />   
                            <TableRecord
                                tableRecords={tableRecords}
                                />
                                
                        
                        
                        
                    </div>
                    <div className="modal-footer justify-content-between">
                        <button
                        type="button"
                        className="btn btn-border btn-default"
                        data-dismiss="modal"
                        onClick={this.props.toggleModel}
                        >
                        {" "}
                        Cancel{" "}
                        </button>
                        <button type="button" data-dismiss="modal" onClick={this.props.saveHandler} className="btn primary_bg" >
                        {" "}
                        Save
                        </button>
                    </div>
                    </div>
                </div>
        </div> }*/}

          
        
    }
}
export default SearchCertificate;